module.exports = __webpack_public_path__ + "img/icon-merck-503291.99937e58.svg";